export default {
  placeholder: 'Search...',
  minLengthHint: 'Minimum {{count}} characters required for search',
};
